import { Icon } from '@eventbrite/eds-icon';
import { ClockChunky, MailChunky } from '@eventbrite/eds-iconography';
import { GenericLazyString } from '@eventbrite/i18n';
import React from 'react';
import {
    TEXT_TOKEN_EXPIRES_TIME,
    TEXT_TOKEN_EXPIRES_TIME_START_OVER,
} from '../../../constants/messages';
import AuthDialog, { IAuthDialogProps } from '../AuthDialog';

export interface IAuthDialogWithExpirationProps extends IAuthDialogProps {
    expirationTimeText?: GenericLazyString;
    startOverText?: GenericLazyString;
    isReferrerMyTickets?: boolean;
}

const AuthDialogWithExpiration = ({
    icon,
    titleText,
    subtitleText,
    expirationTimeText = TEXT_TOKEN_EXPIRES_TIME,
    startOverText = TEXT_TOKEN_EXPIRES_TIME_START_OVER,
    button,
    isReferrerMyTickets,
}: IAuthDialogWithExpirationProps) => {
    const { iconType = <MailChunky />, iconColor = 'ui-700' } = icon ?? {};

    return (
        <div>
            <AuthDialog
                titleText={titleText}
                subtitleTextDark={subtitleText}
                button={button}
                icon={{ iconType, iconColor }}
                noWrapperStyles={true}
            />

            {expirationTimeText && (
                <p className="eds-text--center eds-text-color--grey-600 eds-text-bm eds-l-mar-hor-3">
                    {!isReferrerMyTickets && (
                        <Icon
                            size="small"
                            type={<ClockChunky />}
                            color="grey-600"
                        />
                    )}
                    {!isReferrerMyTickets && expirationTimeText}
                    {isReferrerMyTickets && startOverText}
                </p>
            )}
        </div>
    );
};

export default AuthDialogWithExpiration;
